import { gql, useQuery } from '@apollo/react-hooks';
import type { DrcAdmissionWaive, GetDrcAdmissionWaive } from './types';
import type { FilterType } from '../types';

export const useGetDrcAdmissionWaive = (
  filter: FilterType,
): GetDrcAdmissionWaive => {
  const { data, loading, error, refetch } = useQuery(
    gql`
      query ($filter: AssessmentFilter!) {
        dsrcAdmission(filter: $filter) {
          entranceRequirement
          entranceRequirementWaive
          confirmationChairInTeam
        }
      }
    `,
    {
      variables: { filter },
      fetchPolicy: 'network-only',
    },
  );
  const drcAdmissionWaive: DrcAdmissionWaive = data?.dsrcAdmission ?? {};

  return { drcAdmissionWaive, loading, error, refetch };
};
